import { Value } from '@philips-internal/oswald-ui-core';

export class IntakesAndPutsContext {
  static state: Record<string, Value>;
  static allowUpdates = true;
  static internalNavegation = false;

  private static allowEdit: boolean;

  static set(data: Record<string, Value>): void {
    if (!this.allowUpdates) {
      return;
    }

    this.state = data;
  }

  public static setAllowEdit(allow: boolean): void {
    this.allowEdit = allow;
  }

  static clean(allowUpdates: boolean): void {
    if(this.internalNavegation) {
      return;
    }

    this.state = {};
    this.allowUpdates = allowUpdates;
  }

  static get(): Record<string, Value> {
    return this.state;
  }

  public static getAllowEdit(): boolean {
    return this.allowEdit;
  }

  static setInternalNavegation(state: boolean): void {
    this.internalNavegation = state;
  }
}
